import BodyText from 'LuxKit/Typography/BodyText'
import TextLink from 'LuxKit/TextLink'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import type { ReactNode } from 'react'
import { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  viewOffersTo: string
}

function TriplePointTakeoverBannerDescription(props: Props) {
  const { viewOffersTo } = props
  const [tier] = useCurrentLoyaltyTier()

  const renderViewOffersLink = useCallback((chunks: ReactNode) => {
    return <TextLink key="view-offers-link" to={viewOffersTo} wrap="no-wrap" colour="inherit">{chunks}</TextLink>
  }, [viewOffersTo])

  return <BodyText variant="medium" weight="bold" colour={`tier-${tier}-contrast`}>
    <CSSBreakpoint min="desktop">
      <FormattedMessage
        id="nOTqH8oB6pP4Z78gAIiy"
        defaultMessage="Enjoy triple Société Points on these limited-time offers."
        
      />
    </CSSBreakpoint>
    <CSSBreakpoint max="tablet">
      <FormattedMessage
        id="9eOLaCxkVYRU__LnjF8X"
        defaultMessage="Enjoy triple Société Points on these limited-time offers. <link>View offers</link>"
        
        values={{
          link: renderViewOffersLink,
        }}
      />
    </CSSBreakpoint>
  </BodyText>
}

export default TriplePointTakeoverBannerDescription
